export const checkQueryParam = (key: string, value: string) => {
    const params = new URLSearchParams(location.search)
    return params.get(key) === value
}
